import { useQuery } from '@tanstack/react-query';
import { leadsApi } from '@/core/api/leadsApi';
import type { LeadListQuery } from '@/core/types/lead';

export const leadQueryKeys = {
  all: ['leads'] as const,
  list: (query: LeadListQuery) => ['leads', 'list', query] as const,
  detail: (leadId: string) => ['leads', 'detail', leadId] as const,
};

export const useLeads = (query: LeadListQuery) =>
  useQuery({
    queryKey: leadQueryKeys.list(query),
    queryFn: () => leadsApi.list(query),
  });
